export default import.meta.ROLLUP_FILE_URL_BQF$f7YB;